<template>
    <div class="app-main">
        <el-container direction="vertical">
            <navbar />
            <el-container class="live-container">
                <sidebar v-if="!$store.state.isInfor"/>
                <el-main id="scrollContainer">
                    <div class="app-container">
                        <app-main />
                    </div>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
import Navbar from './components/Navbar'
import Sidebar from './components/Sidebar'
import AppMain from './components/AppMain'

export default {
    name: 'Layout',
    data() {
        return {}
    },
    components: {
        Navbar,
        Sidebar,
        AppMain
    },
    created() {},
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.app-main,.authorize-main{
    height: 100%;
}
.el-container{
    height: 100%;
    .live-container{
        height: calc(100% - 76px);
        padding: 16px 0 16px 8px;
        background-color: #F7F8FA;
        .el-main{
            height: 100%;
            padding: 0 6.2%;
            background-color: #F7F8FA;
            .app-container{
                padding: 0 32px;
                background-color: #fff;
                box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.08);
            }
        }
    }
}
</style>
